import dynamicSubnav from '../../classes/dynamicSubnav';

new dynamicSubnav(document.querySelector('[data-js-dynamic-subnav]'));